export enum BillingRecurringTypes {

        Yearly = 2,
        Monthly = 1

}

export interface INewMemberRequest {
        Checksum: string;
        OrderFormVersion: string;
        FirstName: string;
        LastName: string;
        Email: string;
        Company: string;
        Phone: string;
        Password: string;
        Address1: string;
        City: string;
        State: string;
        ZipCode: string;
        Country: string;
        CC_FirstName: string;
        CC_LastName: string;
        CC_Address1: string;
        CC_City: string;
        CC_State: string;
        CC_ZipCode: string;
        CC_Country: string;
        CC_Number: string;
        CC_ExpMonth: number;
        CC_ExpYear: number;
        CC_CVC: number;
        ProductID: number;
        BillingCycle: BillingRecurringTypes;
        PromoCode: string;
        AssignToOwner: boolean;
        Initials: string;
        RedirectID: number;
        DateTimeRedirectClick: Date;

        AuthorizedContactFirstName : string;
        AuthorizedContactLastName : string;
        AuthorizedContactEmail : string;
        AuthorizedContactNote : string;
}

export class NewMemberRequest implements INewMemberRequest {
        Checksum: string;
        OrderFormVersion: string;
        FirstName: string;
        LastName: string;
        Email: string;
        Company: string;
        Phone: string;
        Password: string;
        Address1: string;
        City: string;
        State: string;
        ZipCode: string;
        Country: string;
        CC_FirstName: string;
        CC_LastName: string;
        CC_Address1: string;
        CC_City: string;
        CC_State: string;
        CC_ZipCode: string;
        CC_Country: string;
        CC_Number: string;
        CC_ExpMonth: any;
        CC_ExpYear: number;
        CC_CVC: number;
        ProductID: number;
        BillingCycle: BillingRecurringTypes;
        PromoCode: string;
        AssignToOwner: boolean = true;
        Initials: string;
        RedirectID: number;
        DateTimeRedirectClick: Date;
        AddYard: boolean;

        AuthorizedContactFirstName : string;
        AuthorizedContactLastName : string;
        AuthorizedContactEmail : string;
        AuthorizedContactNote : string;

}